import React, { useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // Removed useNavigate import
import Home from './components/pages/Home';
import NewsAndEvents from './components/pages/NewsAndEvents';
import Give from './components/pages/Give';
import Financial from './components/pages/Financial';
import ContactUs from './components/pages/ContactUs';
import JoinMc from './components/pages/JoinMc';
import AboutUs from './components/pages/AboutUs';
import Cli from './components/Cli';
import { ServiceTimes } from './components/Time';
import { RoundTableDetails } from './components/WeeklyRoundTable';
import Tcg from './components/Tcg';
import TermsOfService from './components/TermsOfService';
import FitForLife from './components/fitforlife';
import CityChurchKidsPage from './components/CityChurchKidsPage';
import BookLibrary from './components/BookLibrary';
import ConnectionCard from './components/ConnectionCard';
import NeedPrayer from './components/NeedPrayer';
import SupportMission from './components/SupportMission';
import PartnerWithUs from './components/PartnerWithUs';
import Slida from './components/Slida';
import Locations from './components/Locations';
import NewSteps from './components/NewSteps';
import Chatbot from './components/Chatbot';

// ScrollToTop Component to handle scroll reset
const ScrollToTop = () => {
  const location = useLocation(); // Get the current route location

  useEffect(() => {
    // If the URL has a hash, smooth-scroll to that section (e.g. /#programs).
    if (location.hash) {
      const id = location.hash.slice(1);
      // Wait a tick so the target section is mounted after navigation.
      const timer = window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo(0, 0);
      }, 80);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo(0, 0); // Otherwise scroll to top on route change
    return undefined;
  }, [location]); // Runs whenever the route changes

  return null; // This component doesn't render anything visible
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />  {/* This ensures scroll to top on route change */}
      <a className="tcc-skip" href="#main">Skip to main content</a>
      <Navbar />
      <main id="main">
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/news-and-events' element={<NewsAndEvents />} />
        <Route path='/financial' element={<Financial />} />
        <Route path='/give' element={<Give />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/join-mc' element={<JoinMc />} />
        <Route path="/Cli" element={<Cli />} />
        <Route path="/service-times" element={<ServiceTimes />} />
        <Route path="/weekly-round-table" element={<RoundTableDetails />} />
        <Route path="/tcg-page" element={<Tcg />} />
        <Route path="/term-of-service" element={<TermsOfService />} />
        <Route path="/fitforlife" element={<FitForLife />} />
        <Route path="/CityChurchKids" element={<CityChurchKidsPage />} />
        <Route path="/bookLib" element={<BookLibrary />} />
        <Route path="/ConnectionCardLin" element={<ConnectionCard />} />
        <Route path="/PrayerRequestForm" element={<NeedPrayer />} />
        <Route path="/supportMission" element={<SupportMission />} />
        <Route path="/partnerWithUs" element={<PartnerWithUs />} />
        <Route path="/slida" element={<Slida />} />
        <Route path="/location" element={<Locations />} />
        <Route path="/nextSteps" element={<NewSteps />} />
        {/* Fallback route for unmatched paths */}
        <Route path="*" element={<Home />} />
      </Routes>
      </main>
      {/* Chatbot - Accessible on all pages */}
      <Chatbot />
    </Router>
  );
};

export default App;